import { Component, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { distinctUntilChanged, Observable } from 'rxjs';
import { SpecialismList } from '@boels/models';
import { StoreFinderSpecialismDropdownService } from './store-finder-specialism-dropdown.service';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { RoutingService } from '@boels/helpers';
import { AsyncPipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'boels-store-finder-specialisms-dropdown',
  templateUrl: './store-finder-specialism-dropdown.component.html',
  styleUrls: ['./store-finder-specialism-dropdown.component.scss'],
  imports: [
    TranslocoModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormsModule,
    AsyncPipe,
  ],
  providers: [
    StoreFinderSpecialismDropdownService,
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['storeFinder'],
    },
  ],
})
export class StoreFinderSpecialismDropdownComponent {
  #storeFinderSpecialismDropdownService = inject(
    StoreFinderSpecialismDropdownService,
  );
  #routingService = inject(RoutingService);

  specialisms$: Observable<SpecialismList> =
    this.#storeFinderSpecialismDropdownService.specialisms$;
  selected = signal<string>('0');
  faCheck = faCheck;

  constructor() {
    this.#routingService
      .getRoutePropertyAsObservable('queryParams')
      .pipe(
        distinctUntilChanged(
          (prev, curr) => prev?.['specialism'] === curr?.['specialism'],
        ),
        takeUntilDestroyed(),
      )
      .subscribe((routeQueryParams) => {
        const specialism = routeQueryParams?.['specialism'];
        this.selected.set(specialism ?? '0');
      });
  }

  selectSpecialism(specialismCode: string): void {
    this.#storeFinderSpecialismDropdownService.navigateToSpecialism(
      specialismCode,
    );
  }
}
